import type { PopoverProps } from '@mantine/core';

/**
 * Shared Mantine date-picker popover settings (#1447).
 *
 * Uses Floating UI `fixed` positioning so nested drawers/popovers get viewport-correct
 * placement, `shift` + `size` to keep the dropdown fully on-screen, and **no flip above**
 * the input (top placement covers the label + field in tight Set date shells).
 */
export const DATE_INPUT_CALENDAR_POPOVER_PROPS: Partial<PopoverProps> = {
  withinPortal: true,
  floatingStrategy: 'fixed',
  position: 'bottom-start',
  offset: 4,
  middlewares: {
    flip: false,
    shift: { padding: 8 },
    // Padding keeps the dropdown inside the viewport on narrow mobile shells (#1447).
    size: { padding: 8 },
  },
  // Modal-form Escape routing closes the calendar first (#1432); Mantine DateInput still
  // dismisses the dropdown on Escape via its own handler when this is false.
  closeOnEscape: false,
  zIndex: 320,
  styles: {
    dropdown: {
      overflowY: 'auto',
      overflowX: 'auto',
      maxWidth: 'calc(100vw - 16px)',
      maxHeight: 'calc(100dvh - 16px)',
      boxSizing: 'border-box',
    },
  },
};
